import React, {Component} from 'react';
import {connect} from 'react-redux';
// style
import style from '../css/myOffersList.css';
// helpers
import {getText,getFormattedCurrency} from '../../../helpers/localization';
// identifiers
// actions
// configurations

import {ASSETS_URL} from '../../../constants/endpoints';
import { applyPromoBet,openCloseMyOfferList } from '../../../actions/promoBetActions';
import {getItem} from "../../../helpers/localStorageHelpers";
import {OPTED_CAMPAING_IDS} from "../../../constants/localStorage";
import {getPromoBalances,amountConvertToMajorCurrency} from "../helpers/betHelpers";
import {formatTimeToShow} from '../../../helpers/helperFunctions';
/* global BMS*/
const mapStateToProps = (state, ownProps) => {
    return {
        isModalOpen: state.vpp.isModalOpen,
        openModalType: state.vpp.openModalType,
        selectedOddsType: state.vpp.selectedOddsType,
        systemLanguage: state.vpp.systemLanguage,
        isVideoVisible: state.vpp.isVideoVisible,
        promoBalances: state.vpp.promoBalances,
        selectedBet:state.vpp.selectedBet,
        playerBalance: state.vpp.playerBalance
    };
};

class MyOffersList extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();
        this.state = {
            promoBalances: storeData.vpp.promoBalances,
            selectedBet:storeData.vpp.selectedBet,
            playerBalance: storeData.vpp.playerBalance
        }

    }

    _handleRadioButtonChange = event =>{
        //apply promobet by passing promo id from radio buuton selection
        event.stopPropagation();
        this.props.store.dispatch(applyPromoBet(this.state.selectedBet,event.target.value,(process.env.NODE_ENV !== 'development' && BMS && BMS.authentication && BMS.authentication.isPlayerLogged && this.state.playerBalance)
        ? this.state.playerBalance.Banks.CREDIT.MinorCurrencyUnits
        : 2,this.props.store.getState().vpp.systemLanguage, this.props.store.getState().vpp.systemCurrency));
        this.props.store.dispatch(openCloseMyOfferList());
    }

    //to create promo list for UI from valid promolist 
    _createMyOfferList(validPromos){
        let validMyOfferList=[]
        validPromos.map((offer, index) => {
            for(let p=0;p<offer.PromoBetCnt;p++){
                validMyOfferList.push(offer)
            }
        })
        //sort the offerlist according to expire date
        let sortedValidMyOfferList = validMyOfferList.sort(
            (objA, objB) => Number(objA.ExpireDate) - Number(objB.ExpireDate),
          );
        return sortedValidMyOfferList;
    }

    convertAmount(amount, minorCurrencyUnits) {
        if (minorCurrencyUnits === 0) {
            return amount;
        }
        return amount / Math.pow(10, minorCurrencyUnits);
    }

    render() {
        let store = this.props.store;
        let storeData = store.getState();
        let validPromos = getPromoBalances(this.state.promoBalances, getItem(storeData.vpp.playerUID, OPTED_CAMPAING_IDS));

        return (
            <div className={style.myOfferContainer}>
                <div className={style.myOfferHeading}>{getText('MY_OFFERS', store)}</div>
                <div className={style.subHeading}>{getText('CHOOSE_BET', store)}</div>
                <div className={style.offerListContainer}>
                    <table className={style.tableStyle}>
                        <tbody>
                            {this._createMyOfferList(validPromos).map((offer, index) => {
                                if(offer.PromoBetCnt>0)
                                return (<tr key={index}>
                                    <td className={style.promoText}> {getFormattedCurrency(this.props.store, amountConvertToMajorCurrency(offer.PromoBetValue[0],this.state.playerBalance.Banks.CREDIT.MinorCurrencyUnits))}{" "}{getText('PROMO_BET', store)}{" ("}{getText('EXP', store)}{" "}{formatTimeToShow(offer.ExpireDate,this.props.store.getState().vpp.systemLanguage,{month: '2-digit', day: 'numeric',year: '2-digit'}).dayMonthYear}{") "}</td>
                                    <td className={style.radioButtonColoum}><input type="Radio" className={style.radioStyle} id={offer.PromoBetId} name="promobet" onChange={this._handleRadioButtonChange} value={offer.PromoBetId}/>
                                        <label htmlFor={offer.PromoBetId}></label></td>
                                </tr>);
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(MyOffersList);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/myOffersList.js